import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshancab() {



  const cardData = {
"keyword": "Pune to Ashtavinayak Darshan Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Ashtavinayak Darshan Cab service for devotees seeking a safe, convenient, and well-planned spiritual journey. The Ashtavinayak Yatra covers eight sacred Lord Ganesha temples across Maharashtra, and our taxi service ensures a smooth pilgrimage experience with experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges. Whether you are traveling with family, elders, or a group of devotees, we provide flexible one-day, two-day, and customized tour packages from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for all group sizes. With doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a peaceful and hassle-free Ashtavinayak darshan journey.",

"topPlaces": [
  {
    "title": "Morgaon Mayureshwar Ganpati",
    "description":
      "Morgaon is considered the starting point of the Ashtavinayak Yatra and is dedicated to Lord Mayureshwar. Travelers using Pune to Ashtavinayak cab service often begin their pilgrimage here."
  },
  {
    "title": "Siddhatek Siddhivinayak Temple",
    "description":
      "Siddhatek Temple is one of the Ashtavinayak temples located on the banks of the Bhima River and is known for its spiritual significance. Cab travelers from Pune visit this sacred shrine for darshan."
  },
  {
    "title": "Theur Chintamani Ganpati",
    "description":
      "Theur Temple is dedicated to Lord Chintamani Ganesh and is known for its peaceful surroundings and religious importance. Pune to Ashtavinayak taxi service provides easy access for devotees."
  },
  {
    "title": "Ranjangaon Mahaganpati",
    "description":
      "Ranjangaon Mahaganpati is one of the most powerful Ashtavinayak temples associated with Lord Ganesha. Travelers booking Pune to Ashtavinayak cabs often include this temple in their route."
  },
  {
    "title": "Ozar Vighneshwar Temple",
    "description":
      "Ozar Temple is a beautifully constructed Ganpati temple known for its spiritual aura and festivals. Cab from Pune ensures a comfortable pilgrimage experience."
  },
  {
    "title": "Lenyadri Girijatmaj Temple",
    "description":
      "Lenyadri Temple is located inside ancient Buddhist caves and is one of the most unique Ashtavinayak temples. Travelers from Pune enjoy this heritage and spiritual destination."
  },
  {
    "title": "Mahad Varad Vinayak Temple",
    "description":
      "Mahad Temple is known for its calm environment and divine significance in the Ashtavinayak circuit. Pune to Ashtavinayak cab booking is ideal for visiting this sacred site."
  },
  {
    "title": "Pali Ballaleshwar Temple",
    "description":
      "Pali Temple is the only Ashtavinayak shrine where Lord Ganesha is worshipped as Ballaleshwar. Cab travelers from Pune often include this important temple in their itinerary."
  },
  {
    "title": "Ashtavinayak Circuit Scenic Routes",
    "description":
      "The Ashtavinayak route passes through scenic countryside, villages, and river landscapes of Maharashtra. Taxi service from Pune ensures a smooth and comfortable spiritual journey."
  },
  {
    "title": "Jejuri Khandoba Temple (Optional Stop)",
    "description":
      "Jejuri is a famous pilgrimage site dedicated to Lord Khandoba and is often added as an optional stop during Ashtavinayak tours. Travelers from Pune frequently include it in their cab itinerary."
  }
],



services: [
  {
    name: "Pune to Ashtavinayak Cab",
    description: "Pune to Ashtavinayak cab service provides reliable transportation for devotees planning Ashtavinayak Darshan from Pune. Comfortable vehicles with experienced drivers ensure smooth and safe journeys covering all eight Ganpati temples across Maharashtra. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different pilgrimage travel requirements. Flexible booking options allow convenient one-day and multi-day Ashtavinayak yatra reservations."
  },
  {
    name: "Ashtavinayak Darshan Cab Pune",
    description: "Ashtavinayak Darshan cab Pune service offers dependable transportation for devotees traveling to the sacred Ashtavinayak temples from Pune. Vehicles provide comfortable seating and smooth highway travel suitable for family pilgrimages and temple tours. Professional chauffeurs ensure punctual pickup and safe driving services throughout the yatra. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ashtavinayak Darshan cab reservations."
  },
  {
    name: "Pune Ashtavinayak Taxi Service",
    description: "Pune Ashtavinayak taxi service provides comfortable transportation for passengers planning spiritual journeys to the famous Ashtavinayak temples. Vehicles ensure reliable highway and rural road travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for family pilgrimages, group temple visits, and religious tours. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab for Ashtavinayak Yatra Pune",
    description: "Cab for Ashtavinayak yatra Pune service offers reliable transportation with comfortable vehicles and professional drivers for complete temple tour journeys. Vehicles provide smooth travel suitable for spiritual tours, sightseeing, and family pilgrimages. Professional drivers ensure safe driving and timely pickup services throughout the yatra route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy yatra cab reservations."
  },
  {
    name: "Pune to Ashtavinayak Tour Cab",
    description: "Pune to Ashtavinayak tour cab service provides dependable transportation solutions for passengers traveling to all Ashtavinayak temples with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance pilgrimage travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for religious tourism and temple visits. Flexible booking options allow convenient tour cab reservations."
  },
  {
    name: "Ashtavinayak Darshan Taxi Pune",
    description: "Ashtavinayak Darshan taxi Pune service provides transparent and reliable transportation for devotees visiting the sacred Ganpati temples from Pune. Travelers can enjoy comfortable journeys with experienced drivers familiar with pilgrimage routes. Comfortable vehicles ensure smooth travel with safe transportation services throughout the yatra. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi reservations for temple tours."
  },
  {
    name: "Pune Religious Cab Ashtavinayak",
    description: "Pune religious cab Ashtavinayak service provides economical and comfortable transportation for devotees traveling for spiritual and religious purposes. Comfortable vehicles ensure smooth highway travel suitable for temple visits, family pilgrimages, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient religious cab reservations."
  },
  {
    name: "Pune Temple Darshan Cab",
    description: "Pune temple darshan cab service offers convenient transportation for passengers planning temple tours and religious journeys from Pune. Comfortable vehicles provide smooth travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for temple visits, pilgrimage tours, and family spiritual trips. Flexible booking options allow convenient darshan cab reservations."
  },
  {
    name: "One Day Ashtavinayak Cab Pune",
    description: "One day Ashtavinayak cab Pune service allows devotees to complete Ashtavinayak Darshan comfortably within a single-day travel plan. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the temple route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow instant and advance one-day yatra reservations."
  },
  {
    name: "Pune Pilgrimage Cab Ashtavinayak",
    description: "Pune pilgrimage cab Ashtavinayak service provides affordable transportation for families and devotees planning spiritual journeys from Pune. Vehicles ensure reliable highway travel suitable for religious tours, temple visits, and family pilgrimages. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient pilgrimage cab reservations."
  },
  {
    name: "Best Ashtavinayak Cab Pune",
    description: "Best Ashtavinayak cab Pune service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth pilgrimage travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for temple visits, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the yatra. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "SUV Ashtavinayak Cab Pune",
    description: "SUV Ashtavinayak cab Pune service provides spacious transportation for families and groups traveling for Ashtavinayak Darshan. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance pilgrimage journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the temple route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV cab reservations."
  },
  {
    name: "Innova Ashtavinayak Cab Pune",
    description: "Innova Ashtavinayak cab Pune service provides premium SUV transportation for passengers seeking comfortable and reliable pilgrimage travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for temple visits, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the yatra. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Sedan Ashtavinayak Cab Pune",
    description: "Sedan Ashtavinayak cab Pune service offers economical and comfortable transportation for solo travelers, couples, and small families traveling for Ashtavinayak Darshan. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for pilgrimage journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Ashtavinayak Yatra Booking Pune",
    description: "Ashtavinayak yatra booking Pune service offers dependable transportation and travel planning for devotees visiting all eight Ganpati temples from Pune. Comfortable vehicles ensure smooth highway travel suitable for temple tours, spiritual journeys, and family pilgrimages. Professional chauffeurs ensure safe driving and reliable transportation services throughout the yatra route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ashtavinayak yatra reservations."
  }
],

tableData: [
  ["Pune to Ashtavinayak Cab", "Ashtavinayak Darshan Cab Pune"],
  ["Pune Ashtavinayak Taxi Service", "Cab for Ashtavinayak Yatra Pune"],
  ["Pune to Ashtavinayak Tour Cab", "Ashtavinayak Darshan Taxi Pune"],
  ["Pune Religious Cab Ashtavinayak", "Pune Temple Darshan Cab"],
  ["One Day Ashtavinayak Cab Pune", "Pune Pilgrimage Cab Ashtavinayak"],
  ["Best Ashtavinayak Cab Pune", "SUV Ashtavinayak Cab Pune"],
  ["Innova Ashtavinayak Cab Pune", "Sedan Ashtavinayak Cab Pune"],
  ["Ashtavinayak Yatra Booking Pune", "Pune to Ashtavinayak Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Ashtavinayak Darshan Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Ashtavinayak Darshan cab service with professional drivers, comfortable vehicles, and well-planned travel routes for smooth pilgrimage journeys."
      },
      {
        WhyChooseheading: "Affordable Ashtavinayak Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Ashtavinayak Darshan cab pricing with transparent fare details and no hidden charges. Customers receive complete package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Ashtavinayak Cab Availability",
        WhyChoosedescription: "Our Pune to Ashtavinayak Darshan cab service operates 24 hours a day for temple visits, family pilgrimage tours, group travel, and customized religious travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during the complete Ashtavinayak Darshan tour."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-day Ashtavinayak Darshan tours, multi-day temple packages, round-trip bookings, and customized pilgrimage travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, pilgrims, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with all eight Ashtavinayak temple routes and ensure safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ashtavinayak Darshan cab service?", answer: "Pune to Ashtavinayak Darshan cab service provides comfortable taxi transportation for visiting all eight famous Ganpati temples in Maharashtra." },
    { question: "Is Ashtavinayak Darshan cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Ashtavinayak Darshan cab service." },
    { question: "Which vehicles are available for Ashtavinayak Darshan travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-day Ashtavinayak Darshan tour?", answer: "Yes, customers can book one-day as well as multi-day Ashtavinayak Darshan taxi packages." },
    { question: "Do you provide customized temple tour packages?", answer: "Yes, Shivai Travels provides customized pilgrimage and temple travel packages as per customer requirements." },
    { question: "Are all Ashtavinayak taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Pune to Ashtavinayak Darshan cab service online?", answer: "Yes, customers can easily book Ashtavinayak Darshan cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Ashtavinayak Darshan cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Ashtavinayak Darshan cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Deshmukh",
    feedback:
      "Shivai Travels provided a very smooth Pune to Ashtavinayak Darshan cab service with a comfortable vehicle and an experienced driver who ensured a peaceful temple visit across all locations.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback:
      "The Ashtavinayak Darshan cab service from Pune was very well organized with timely pickup, safe driving, and a hassle-free pilgrimage experience for our family.",
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Cab Service",
  "image": "https://shivaitravels.com/assets/images/ashtavinayak-darshan-cab.jpg",
  "description": "Book Pune to Ashtavinayak Darshan cab service for safe and comfortable pilgrimage travel. Shivai Travels offers one-day and multi-day Ashtavinayak yatra packages with sedan, SUV, Innova, and luxury cab options available 24x7 for temple darshan tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/ashtavinayak-darshan-cab-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Ashtavinayak Darshan Cab Pune | Temple Yatra Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Ashtavinayak Darshan cab service for one-day and multi-day temple yatra. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for pilgrimage tours."
  />

  <meta
    name="keywords"
    content="pune to ashtavinayak cab, ashtavinayak darshan cab pune, pune ashtavinayak taxi service, cab for ashtavinayak yatra pune, pune to ashtavinayak tour cab, ashtavinayak darshan taxi pune, pune religious cab ashtavinayak, pune temple darshan cab, one day ashtavinayak cab pune, pune pilgrimage cab ashtavinayak, best ashtavinayak cab pune, suv ashtavinayak cab pune, innova ashtavinayak cab pune, sedan ashtavinayak cab pune, ashtavinayak yatra booking pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakdarshancab;